module.exports = __webpack_public_path__ + "img/rzo-background.c6a361f6.jpg";